<template>
  <b-form @submit.prevent="save">
    <SettingsTitleBar sub="Emails" :saving="saving" />

    <b-form-checkbox v-model="form.requireNotifyEmail">Require Manager Notification</b-form-checkbox>
  </b-form>
</template>
<style scoped lang="scss">
small {
  display: block;
  color: #999;
  margin-bottom: 1em;
}
label.label {
  display: block;
  font-size: 1.3em;
  font-weight: bold;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      saving: false,
      form: {}
    }
  },
  mounted() {
    this.form = {
      requireNotifyEmail: false,
      ...this.approvalSettings
    };
  },
  computed: {
    ...mapGetters(['approvalSettings']),
  },
  methods: {
    ...mapActions(['updateTeam']),
    async save() {
      this.saving = true;
      let approval_settings = {...this.approvalSettings, ...this.form};
      await this.updateTeam({approval_settings});
      this.saving = false;
      this.$router.push('/dashboard/settings');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/EditEmails.vue